import React, { useState } from 'react';
import { DownloadIcon, Loader2Icon } from 'lucide-react';
import type { Partner } from '../../types/partners';
import { downloadFile } from '../../utils/download';
import { trackEvent } from '../../utils/analytics';
import { cn } from '../../src/lib/utils';
type DownloadButtonProps = {
  partner: Partner;
  url: string;
  fileName: string;
  /** Analytics id, e.g. "patent_landscape" or "one_pager". */
  documentId: string;
  label?: string;
  ariaLabel?: string;
  className?: string;
};
export function DownloadButton({
  partner,
  url,
  fileName,
  documentId,
  label = 'Download',
  ariaLabel,
  className
}: DownloadButtonProps) {
  const [busy, setBusy] = useState(false);
  const handleClick = async () => {
    if (busy) return;
    setBusy(true);
    trackEvent('partner_document_download', {
      partner_id: partner.id,
      partner_name: partner.name,
      document_id: documentId
    });
    await downloadFile(url, fileName);
    setBusy(false);
  };
  return <button type="button" onClick={handleClick} disabled={busy} aria-label={ariaLabel} aria-busy={busy} className={cn('inline-flex min-h-[40px] items-center justify-center gap-1.5 rounded-lg border border-hairline bg-panel px-3 text-sm font-semibold text-text-primary transition-colors hover:bg-elevated focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-lime disabled:cursor-wait', className)} data-id="element-855" data-mp="25wnmgfr2bjyg">
      {busy ? <Loader2Icon className="h-4 w-4 animate-spin" aria-hidden="true" data-id="element-856" data-mp="1ssew9pdj6kz7" /> : <DownloadIcon className="h-4 w-4" aria-hidden="true" data-id="element-857" data-mp="1wts6ebnnpabx" />}
      {label}
    </button>;
}